/**
 * Product Personalization Module
 * Handles validation, visibility, and interaction logic for the personalization feature
 */

document.addEventListener('DOMContentLoaded', function () {
  const checkbox = document.getElementById('perso_active');
  const fields = document.getElementById('perso_fields');
  const personnalisationBlock = document.getElementById('product-personnalisation');
  const texteInput = document.getElementById('perso_texte');

  // Exit if elements don't exist
  if (!checkbox || !fields || !personnalisationBlock || !texteInput) {
    return;
  }

  const excludedOptionsRaw = personnalisationBlock.getAttribute('data-excluded-options');
  const parsedExcludedOptions = excludedOptionsRaw ? JSON.parse(excludedOptionsRaw) : null;
  const hiddenKeywords = Array.isArray(parsedExcludedOptions) ? parsedExcludedOptions.map(k => k.toLowerCase()) : [];

  /**
   * Update personalization block visibility based on product variant option1
   */
  function updatePersonnalisationVisibility() {
    if (window.product && window.product.selectedVariant && window.product.selectedVariant.option1) {
      const option1 = window.product.selectedVariant.option1.toLowerCase();

      // Hide block if option1 contains any of the keywords
      const shouldHide = hiddenKeywords.some(keyword => option1.includes(keyword));

      if (shouldHide) {
        personnalisationBlock.classList.add('hidden');
        checkbox.checked = false;
        fields.classList.add('hidden');
      } else {
        personnalisationBlock.classList.remove('hidden');
      }
    }
  }

  // Wait for window.product to be defined
  let waitForProduct = setInterval(function () {
    if (window.product && window.product.selectedVariant) {
      clearInterval(waitForProduct);
      updatePersonnalisationVisibility();
    }
  }, 50);

  // Timeout after 5 seconds
  setTimeout(() => clearInterval(waitForProduct), 5000);

  // Listen to variant changes
  const optionsContainer = document.querySelector('#product-options');
  if (optionsContainer) {
    optionsContainer.addEventListener('change', function (e) {
      if (e.target.type === 'radio') {
        setTimeout(() => updatePersonnalisationVisibility(), 100);
      }
    });
  }

  // Listen to select option changes
  const selects = document.querySelectorAll('select[name^="option"]');
  selects.forEach(select => {
    select.addEventListener('change', function () {
      updatePersonnalisationVisibility();
    });
  });

  // Handle checkbox to show/hide fields
  checkbox.addEventListener('change', function () {
    fields.classList.toggle('hidden', !checkbox.checked);
  });

  /**
   * Determine maximum repetitions allowed for a character type
   * @param {string} char - The character to check
   * @returns {number} Maximum allowed repetitions
   */
  function getMaxCountForChar(char) {
    if (char === ' ') return Infinity; // espaces illimités
    if (char === '.') return 3;        // point : max 3
    if (char === "'") return 2;        // apostrophe : max 2
    if (/[A-Z]/.test(char)) return 3;      // A-Z: 3 max
    if (/[0-9]/.test(char)) return 2;      // 0-9: 2 max
    return 1;                               // Others: 1 max
  }

  /**
   * Validate and limit input based on:
   * - Heart emoji conversion (any heart emoji → ♥)
   * - Star emoji conversion (any star emoji → ★)
   * - Allowed characters from data attribute
   * - Character repetition limits
   * - Total character limit (maxlength)
   */
  texteInput.addEventListener('input', function () {
    const originalValue = texteInput.value;
    let value = originalValue;

    // Convert any star emoji to ★ character (⭐🌟🌠💫✨☆✩-✰⭑⭒✳✴❇)
    // Done BEFORE hearts: otherwise the trailing \uFE0F of "⭐️" is caught by the heart regex.
    const starEmojis = /[\u{2B50}\u{1F31F}\u{1F320}\u{1F4AB}\u{2728}\u{2605}\u{2606}\u{2729}\u{272A}\u{272B}\u{272C}\u{272D}\u{272E}\u{272F}\u{2730}\u{2B51}\u{2B52}\u{2733}\u{2734}\u{2747}]\u{FE0F}?/gu;
    value = value.replace(starEmojis, '★');

    // Convert any heart emoji to ♥ character
    // This regex matches all heart emojis including:
    // ❤️🧡💛💚💙💜🖤🤍🤎🩷🩵🩶💔❣️💕💞💓💗💖💘💝💟♥️💌💋❤️‍🔥❤️‍🩹
    const heartEmojis = /[\u2764\uFE0F\u{1F9E1}\u{1F49B}\u{1F49A}\u{1F499}\u{1F49C}\u{1F5A4}\u{1F90D}\u{1F90E}\u{1FA77}\u{1FA75}\u{1FA76}\u{1F494}\u{2763}\u{1F495}\u{1F49E}\u{1F493}\u{1F497}\u{1F496}\u{1F498}\u{1F49D}\u{1F49F}\u{2665}\u{1F48C}\u{1F48B}\u{1F525}\u{1FA79}]|\u2764\uFE0F\u200D[\u{1F525}\u{1FA79}]/gu;
    value = value.replace(heartEmojis, '♥');

    // Convert to uppercase for validation
    value = value.toUpperCase();

    const allowedCharacters = texteInput.getAttribute('data-available-characters') || '';
    let newValue = '';

    // Iterate through each character input
    for (let i = 0; i < value.length; i++) {
      const char = value[i];

      // Check if character is allowed
      if (allowedCharacters.indexOf(char) === -1) {
        continue; // Skip disallowed characters
      }

      // Count occurrences of current character in new value
      const count = (newValue + char).split(char).length - 1;
      const maxCount = getMaxCountForChar(char);

      // Add character only if max repetitions not exceeded
      if (count <= maxCount) {
        newValue += char;
      }
    }

    // Update input if value changed from original
    if (originalValue !== newValue) {
      texteInput.value = newValue;
    }
  });

  /**
   * Remove error styling when user starts typing in fields
   */
  texteInput.addEventListener('input', function () {
    texteInput.classList.remove('error-field');
  });

  const couleurSelect = document.getElementById('perso_foil');
  if (couleurSelect) {
    couleurSelect.addEventListener('change', function () {
      couleurSelect.classList.remove('error-field');
    });
  }
});